var map = {
	"./admin.svg": "7970",
	"./dashboard.svg": "6912",
	"./events.svg": "240d",
	"./graphs.svg": "5ae5",
	"./info.svg": "f49a",
	"./login.svg": "ac22",
	"./logout.svg": "7428",
	"./pipeline.svg": "5494",
	"./settings.svg": "ec21",
	"./user.svg": "631a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47bb";